import { useQuery } from "react-query";
import axios from "infra/http";
import { OperacaoEnum } from 'resources/enums/conta';

function useContasRecorrentesNaoLancadas(operacao?: OperacaoEnum, mes?: string) {
  return useQuery(
    [`/v1/conta-recorrente/nao-lancadas`, operacao, mes],
    async () => {
      const { data } = await axios.get<{quantidade: number; ids: string[]}>(
        `/v1/conta-recorrente/nao-lancadas`,
        {
          params: {
            operacao,
            mes,
          },
        }
      );

      return data;
    },
    {
      enabled: !!operacao && !!mes,
    }
  );
}

export default useContasRecorrentesNaoLancadas;
